import JoinOurTeamHeader from "./JoinOurTeamHeader";
import Vacancies from "./Vacancies";

interface Props {
  description: string;
  setSubject: (subject: string) => void;
}

const JoinOurTeamContainer = ({ setSubject, description }: Props) => (
  <section className="bg-white py-[7rem]">
    <div className="global-container 2xl:px-0">
      <JoinOurTeamHeader title="Join Our Team" subtitle={description} />
      <Vacancies setSubject={setSubject} />
    </div>
  </section>
);

export default JoinOurTeamContainer;
